import { observer } from "mobx-react-lite";
import Wallets from "../../components/financier/wallets/Wallets";
import FinancierSharedView from "../shared/FinancierSharedView";

export default observer(function FinancierWallet() {
  return <FinancierSharedView mainContent={<Wallets />} />;
});
